export const CAMPAIGN_CADENCES_TYPE_TAB_KEY = Object.freeze({
  MARKETING: 'marketing',
  TRIGGERS: 'triggers',
});

export const CAMPAIGN_CADENCES_TYPE_TABS = [
  { key: CAMPAIGN_CADENCES_TYPE_TAB_KEY.MARKETING, label: 'Marketing' },
  { key: CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS, label: 'Triggers' },
];

export const CAMPAIGN_CADENCES_CHANNEL_TABS = [
  { key: 'email', label: 'Email Templates' },
  { key: 'text', label: 'Text Templates' },
];
